import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Utility class that provides useful utility functions for HTML.
 * @namespace
 *
 * @private
 */

var HTMLUtils = /*#__PURE__*/function () {
  function HTMLUtils() {
    _classCallCheck(this, HTMLUtils);
  }

  _createClass(HTMLUtils, null, [{
    key: "unescapeEntities",

    /**
     * Decodes or un-escapes html entities in an input string.
     *
     * @static
     * @param {string} text text to decode
     * @returns decoded result or empty string if null or undefined
     * @memberof HTMLUtils
     */
    value: function unescapeEntities() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var escapedCharacterMap = {
        '&lt;': '<',
        '&gt;': '>'
      };
      return text.replace(/(&lt;|&gt;)/g, function (str, item) {
        return escapedCharacterMap[item];
      });
    }
    /**
     * Searches urlString and gets the url parameter value for key.
     *
     * Reason: URLSearchParams does not work with IE11/Edge.
     * Reference: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8993198/
     *
     * @param key parameter name.
     * @param urlString url string containing key value parameters.
     * @returns value for key or empty string if key not found.
     * @memberof HTMLUtils
     */

  }]);

  return HTMLUtils;
}();

_defineProperty(HTMLUtils, "getUrlParameter", function (key, urlString) {
  var _context;

  var cleanedKey = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp(_concatInstanceProperty(_context = "[\\?&]").call(_context, cleanedKey, "=([^&#]*)"));
  var result = regex.exec(urlString);
  return result === null ? '' : decodeURIComponent(result[1].replace(/\+/g, ' '));
});

export { HTMLUtils as default };